import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetPreferencesResponse } from './get-preferences-response';
import { getPreferencesResponseSchema } from './get-preferences-response';

export async function getPreferencesApi(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetPreferencesResponse>> {
  return getRequest<IGetPreferencesResponse>({
    path: '/account/preferences',
    schema: getPreferencesResponseSchema,
    options,
  });
}
